import * as React from 'react';
import Box from '@mui/material/Box';
import { Button, Typography } from '@mui/material';
import CustomizedDialogs from '../../../components/dialogCustom';
import { alpha } from '@mui/material/styles';

export default function BoxBasic({onClickLeftButton, onClickRightButton}) {
  const [isOpenDialog, setOpenDialog] = React.useState(false);

  // const handleDialogOpen = () => {
  //   setOpenDialog(true);
  // };
  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  return (
    <Box position="relative" component="section" sx={{ p: 2, flex: 1, overflow: 'auto' }}>
      <Box component="section" sx={{
        width: '95%',
        position: 'absolute',
        bottom: '30%',
        paddingLeft: 2
      }}>
        <Box sx={{
          width: '100%',
          height: 'auto',
        }}>
          {/* 在https://fonts.google.com/中挑选字体, 选好之后在app.css引用 */}
          {/* 如: @import url('https://fonts.googleapis.com/css2?family=WDXL+Lubrifont+JP+N&display=swap'); */}
          <Typography variant='h6' sx={{ color: 'white', fontFamily: '"WDXL Lubrifont JP N", sans-serif' }}>
            @COCO
          </Typography>
          <Typography variant='h3' sx={{ color: 'white', fontFamily: '"WDXL Lubrifont JP N", sans-serif', fontWeight: 900 }}>
            EXCEL要学会
          </Typography>
          <Typography variant='h3' sx={{color: 'white', fontFamily: '"WDXL Lubrifont JP N", sans-serif', fontWeight: 900 }}>
            高薪又不累
          </Typography>
        </Box>
        <Box sx={{
          width: '100%',
          height: 'auto',
          display: 'flex',
          flexDirection: 'row',
          marginTop: '25px'
        }}> 
          <Button
            variant="contained"
            // onClick={() => handleDialogOpen(!isOpenDialog)}
            onClick={onClickLeftButton}
            sx={{
            color: '#EFDDD0',
            backgroundColor: '#EF7F95',
            '&:hover': {
              backgroundColor: alpha('#EF7F95', 0.8)
            },
            borderRadius: '0px',
            height: '45px',
            marginRight: 1,
            fontWeight: 900,
            fontSize: 17
            }}>
              立即了解
          </Button>
          <Button
            variant="contained"
            // onClick={() => handleDialogOpen(!isOpenDialog)}
            onClick={onClickRightButton}
            sx={{
              color: '#EFDDD0',
              backgroundColor: '#EF7F95',
              '&:hover': {
                backgroundColor: alpha('#EF7F95', 0.8)
            },
            borderRadius: '0px',
            height: '45px',
            marginLeft: 1,
            fontWeight: 900,
            fontSize: 17
            }}>
              课程体验
          </Button>
        </Box>
      </Box>
      <CustomizedDialogs isOpenDialog={isOpenDialog} onClickClose={handleDialogClose}/>
    </Box>
  );
}